export default __webpack_public_path__ + "static/media/2.8998aa13.png";